import { GetListResponse } from "@/openapi/manage/complaint";

/**
 * 反馈入口
 */
export enum FeedbackEntry {
  /**
   * 我要反馈
   */
  FEEDBACK = "1",
  /**
   * 反馈记录
   */
  RECORD = "2",
  /**
   * 反馈记录详情
   */
  RECORD_DETAIL = "3",
}

/**
 * 回复状态
 */
export enum FeedbackReplyStatus {
  /**
   * 待回复
   */
  WAIT = 0,
  /**
   * 已回复
   */
  REPLIED = 1,
}

/**
 * 反馈类型
 */
export enum FeedbackInfoType {
  /**
   * 我的反馈
   */
  MY_FEEDBACK = 1,
  /**
   * 回复记录
   */
  REPLY = 2,
  /**
   * 评分
   */
  SCORE = 3,
}

/**
 * 反馈评价
 */
export enum FeedbackEvaluationType {
  /**
   * 可以评价
   */
  CAN_EVALUATE = 1,
  /**
   * 不可评价
   */
  CANNOT_EVALUATE = 0,
}

export type FeedbackItemType = GetListResponse["dataList"][number];

export interface FeedbackFormRef {
  onReset: () => void;
}
